import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { MessageCircle } from "lucide-react";

import Header from "../components/Header";
import Footer from "../components/Footer";
import FloatingButtons from "../components/FloatingButtons";
import PageBanner from "../components/PageBanner";
import { sssCategories } from "../data/siteData";
import { useZeoContent } from "../lib/ZeoContentContext";

export default function SSS() {
  const { faqs: adminFaqs, business } = useZeoContent();

  // Panelden eklenen sorular varsa "Genel Sorular" grubu olarak en üste eklenir;
  // mevcut kategorize edilmiş içerik olduğu gibi altında kalmaya devam eder.
  const groups = adminFaqs && adminFaqs.length > 0
    ? [{ category: "Genel Sorular", items: adminFaqs }, ...sssCategories]
    : sssCategories;

  return (
    <div className="min-h-screen bg-white text-[#222222]" data-testid="sss-page">
      <Header />

      <PageBanner
        eyebrow="Yardım"
        title="Sıkça Sorulan Sorular"
        subtitle="Sipariş, teslimat, ürün bakımı ve iade süreçlerimizle ilgili en çok merak edilen sorular ve cevapları."
        breadcrumb={[{ label: "Sıkça Sorulan Sorular" }]}
      />

      <section className="py-16 md:py-20 bg-white">
        <div className="frida-container max-w-4xl mx-auto">
          {groups.map((group, gi) => (
            <div key={group.category} className={gi > 0 ? "mt-12" : ""} data-testid={`sss-group-${group.category}`}>
              <h2 className="font-serif text-2xl md:text-3xl text-[#222222] mb-5">{group.category}</h2>
              <Accordion type="single" collapsible className="space-y-3">
                {group.items.map((f, i) => (
                  <AccordionItem
                    key={i}
                    value={`${gi}-${i}`}
                    className="bg-[#F8F8F8] border border-[#EAEAEA] rounded-2xl px-6 lg:px-8 [&[data-state=open]]:border-[#A85C34] transition-colors"
                  >
                    <AccordionTrigger className="font-serif text-lg text-[#222222] py-5 text-left hover:no-underline">
                      {f.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-[#555555] leading-relaxed pb-5 text-base">
                      {f.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}

          <div className="mt-16 bg-[#222222] rounded-[32px] p-10 md:p-14 text-center">
            <h3 className="font-serif text-2xl md:text-3xl text-white mb-3">Cevabını bulamadınız mı?</h3>
            <p className="text-white/70 mb-7 max-w-md mx-auto">
              7/24 hizmet veren danışmanlarımız size yardımcı olmaktan memnuniyet duyar.
            </p>
            <a
              href={business.social.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-7 py-4 bg-[#25D366] hover:bg-[#1ebc59] text-white rounded-full font-medium transition-colors"
              data-testid="sss-whatsapp-cta"
            >
              <MessageCircle className="w-4 h-4" />
              WhatsApp'tan Yazın
            </a>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingButtons />
    </div>
  );
}
